export enum DelinquentStage {
  NEW = 'NEW',
  LOCKED = 'LOCKED',
  CANCELLED = 'CANCELLED',
}

export default null
